<div class="led-container">
  <div class="action-wrapper">
    <p>Easily manage and update a legal entity's documents.</p>
    @if (canUploadDocuments) {
      <app-az-button
        data-testid="docs-replace-file-btn"
        [label]="'Replace File'"
        [icon]="'upload'"
        (click)="openModal()"
      ></app-az-button>
    }
  </div>

  <div *ngIf="loading" class="loading-overlay" aria-live="polite" aria-label="Loading documents">
    <div class="overlay-content">
      <app-spinner [display]="true" [diameter]="48" aria-label="Loading"></app-spinner>
      <span>Loading documents…</span>
    </div>
  </div>

  <app-az-table
    [data]="documents"
    [columns]="columns"
    [actions]="actions"
    [emptyMessage]="'No documents available for this legal entity.'"
    (rowClick)="onRowClick($event)"
  ></app-az-table>
</div>

<app-az-document-update-modal
  [isOpen]="isModalOpen"
  [documentTypes]="documentTypes"
  [allowedFileTypes]="allowedFileTypes"
  [isUploading]="uploading"
  (close)="closeModal()"
  (upload)="handleUpload($event)"
></app-az-document-update-modal>

<app-status-change-modal
  [isOpen]="isStatusModalOpen"
  [title]="'Document Upload'"
  [initialState]="'success-with-message'"
  (close)="closeStatusModal()"
></app-status-change-modal>

<!-- DDQ Template Confirmation Modal -->
<app-status-change-modal
  [isOpen]="showDdqConfirmModal"
  [title]="'Confirm DDQ Template Upload'"
  [initialState]="'custom-confirm'"
  [customMessage]="
    'You have uploaded a modified version of the DDQ. Would you like to save and send it to the DDQ Nominee (' +
    ddqNomineeName +
    ')?'
  "
  [customYesButtonLabel]="'Yes, Save and Send'"
  [customNoButtonLabel]="'No, Delete and Modify Again'"
  (customYes)="onConfirmDdqUpload()"
  (customNo)="onCancelDdqUpload()"
  (close)="closeDdqConfirmModal()"
></app-status-change-modal>

<!-- LOA (Signed 2/2) Confirmation Modal -->
<app-status-change-modal
  [isOpen]="showLoaConfirmModal"
  [title]="'Upload LOA'"
  [initialState]="'custom-confirm'"
  [customMessage]="'Once the LOA (Signed 2/2) document is uploaded, LOA (Signed 1/2) will be deleted.\n\nAre you sure you want to upload this document? This action cannot be undone.'"
  [customYesButtonLabel]="'Yes'"
  [customNoButtonLabel]="'No'"
  (customYes)="onConfirmLoaUpload()"
  (customNo)="onCancelLoaUpload()"
  (close)="closeLoaConfirmModal()"
></app-status-change-modal>

<!-- Processing Modal -->
<app-status-change-modal
  [isOpen]="showProcessingModal"
  [title]="'Uploading Document'"
  [initialState]="'processing'"
  (close)="closeProcessingModal()"
></app-status-change-modal>

<!-- DDQ Template Success Modal -->
<app-status-change-modal
  [isOpen]="showDdqSuccessModal"
  [initialState]="'success-with-message'"
  [title]="'DDQ Nominee'"
  [successMessage]="
    'The updated DDQ document has been successfully sent to the DDQ Nominee ' + ddqNomineeName + '.'
  "
  [warningMessage]="'The DDQ Nominee might not have access to the BCR Portal. Please add them as a Portal User via '"
  [warningLinkText]="'SailPoint'"
  [warningLinkUrl]="'https://astrazeneca.identitynow.com/ui/d/mysailpoint'"
  (close)="closeDdqSuccessModal()"
></app-status-change-modal>
